module.exports = __webpack_public_path__ + "img/psm_logo-inverse.0f7cab20.png";